import axios from "axios";
import api from "../Api";
import { BaseService } from "../BaseService";

const URL = "plans/subscriptions";

export class CheckoutService extends BaseService {
  async list(): Promise<any> {
    try {
      return this.handleResponse(await axios.get(`/mock/platform.json`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async fetch(params: any): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/checkout`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
